import { useEffect } from "react";

import { ApiInstance } from "utils/Api";

export const useAxiosProgress = (setProgress: (progress: number) => void) => {
  useEffect(() => {
    ApiInstance.addProgressBarHook(setProgress);
    return () => {
      ApiInstance.removeProgressBarHook(setProgress);
    };
  }, [setProgress]);
};
